import {
  SEARCH_LIST_REQUEST,
  SEARCH_LIST_SUCCESS,
  SEARCH_LIST_FAIL,
} from '../../constants/categoryConstants'

const initialState = {
  loading: false,
  search: [],
  error: null,
};

export const searchListReducer = (state = initialState, action) => {
  switch (action.type) {
    case SEARCH_LIST_REQUEST:
      return { ...state, loading: true, search: [], error: null };
    case SEARCH_LIST_SUCCESS:
      return { ...state, loading: false, search: action.payload, error: null };
    case SEARCH_LIST_FAIL:
      return { ...state, loading: false, search: [], error: action.payload };
    default:
      return state;
  }
};
